export default "__VITE_ASSET__Cm697mzj__"